import React from 'react';

const SuitByBankPage = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
      Suit By Bank Page
    </div>
  );
};

export default SuitByBankPage;
